import { Container } from 'unstated'

export class PageJumpState extends Container {
  state = {
    pageHasJumpedToPosition: 0,
    pageIsJumping: false,
    pageJumpTargetId: null
  }

  setPageJump = ({
    pageHasJumpedToPosition,
    pageIsJumping,
    pageJumpTargetId
  }) => {
    this.setState({
      pageHasJumpedToPosition,
      pageIsJumping,
      pageJumpTargetId
    })
  }
}
